import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@etnas/design-system/tokens.css';
import '@etnas/design-system/etnas.css';
import './styles/app.css';
import { configureClient } from './api';
import { applyTheme, initialTheme } from './app/theme';
import { installConnectivity } from './app/shell/connectivity';
import { installScrollableRegions } from './app/a11y';
import App from './App';

async function boot() {
  applyTheme(initialTheme());
  // Live is the default even without a local .env; only explicit mock mode loads synthetic data.
  // Keep a direct comparison so live builds drop the mock chunk entirely (static replacement + DCE).
  if (import.meta.env.VITE_API_MODE === 'mock') {
    // The mock is loaded only in mock mode and only here; feature code never imports it.
    const mock = await import('./mock');
    configureClient({ fetch: mock.mockFetch as typeof fetch });
    const { mountMockPanel } = await import('./mock/MockPanel');
    mountMockPanel();
  } else {
    configureClient({ fetch: (...a) => globalThis.fetch(...a) });
  }
  installConnectivity();
  installScrollableRegions();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
boot();
